import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import DocSteps from "../../../components/yourAssets/DocSteps";
import Steps from "../../../components/yourAssets/Steps";
import BankBalances from "./BankBalances";
import RealEstate from "./RealEstate";
import Securities from "./Securities";
import Insurance from "./Insurance";
import GoldRawMaterials from "./GoldRawMaterials";
import ShareHoldings from "./Shareholdings";
import CorporateShareholdings from "./CorporateShareholdings";
import Sonstiges from "./Sonstiges";
import "../../../components/yourAssets/BOA/BOA.scss";
import { customTab, nextTab, preTab } from "../../../redux/slices/TabSlices";
import { getAssetsOnBoardingList } from "../../../redux/slices/features/assetsOnBoardingSlice";
import { connect } from "react-redux";
import { resetCard } from "../../../redux/slices/CardSlices";
import { visited } from "../../../redux/slices/features/assetsOnBoardingSlice";
import { getSBText } from "../../../utils/suggestionBoxUtilities";
import { getAutditTrail } from "../../../services/auditTrails";
import { getUpdatedData } from "../../../redux/slices/AuditTrailSlice";
import { getUserIdFromLocalStorage } from "../../../utils/Utilities";
import Loans from "./Loans";
import { getAssetsTabDocument } from "../../../services/yourAssets/CommonServices";
import { getAssetsDocuments } from "../../../redux/slices/yourAssets/AssetsDocumentsSlice";

const BOA = ({ currentTab, nextTab, preTab, customTab, resetCard }) => {
  let uID = getUserIdFromLocalStorage();
  let currentConsultantId = localStorage.getItem("currentConsultantId");
  const dispatch = useDispatch();
  const tabStatuses = useSelector(
    (state) => state.assetsOnBoarding.assetsSuggestionBoxText
  );
  const reloadAssetsFiles = useSelector(
    (state) => state.assetsDocuments.documents.reload
  );

  useEffect(() => {
    dispatch(getAssetsOnBoardingList());
  }, []);
  useEffect(() => {
    fetchDocumentList();
  }, [reloadAssetsFiles]);

  const updates = useSelector((state) => state.auditTrail.updates);
  const fetchAuditTrail = async () => {
    const result = await getAutditTrail(currentConsultantId);
    if (result?.success) {
      dispatch(getUpdatedData(result?.payLoad));
    } else {
      dispatch(getUpdatedData([]));
    }
  };
  const fetchDocumentList = async () => {
    const result = await getAssetsTabDocument(uID);
    if (result?.success) {
      dispatch(getAssetsDocuments(result.payLoad.items));
    }
  };
  useEffect(() => {
    fetchAuditTrail();
  }, [currentTab]);
  const handleResetCard = () => {
    resetCard();
  };
  const next = () => {
    handleResetCard();
    nextTab();
  };
  const back = () => {
    handleResetCard();
    preTab();
  };
  const handleCustomTab = (val) => {
    customTab(val);
  };

  const renderTab = () => {
    if (currentTab === 1)
      return <RealEstate tabText={tabStatuses[8]} next={next} />;
    else if (currentTab === 2)
      return <BankBalances tabText={tabStatuses[4]} next={next} back={back} />;
    else if (currentTab === 3)
      return <Securities tabText={tabStatuses[1]} next={next} back={back} />;
    else if (currentTab === 4)
      return <Insurance tabText={tabStatuses[3]} next={next} back={back} />;
    else if (currentTab === 5)
      return (
        <GoldRawMaterials tabText={tabStatuses[7]} next={next} back={back} />
      );
    else if (currentTab === 6)
      return <ShareHoldings tabText={tabStatuses[9]} next={next} back={back} />;
    else if (currentTab === 7)
      return (
        <CorporateShareholdings
          tabText={tabStatuses[5]}
          next={next}
          back={back}
        />
      );
    else if (currentTab === 8)
      return <Loans tabText={tabStatuses[0]} next={next} back={back} />;
    else if (currentTab === 9)
      return <Sonstiges tabText={tabStatuses[2]} next={next} back={back} />;
  };

  return (
    <>
      <Steps tab={currentTab} back={back} custom={handleCustomTab} />
      {renderTab()}
    </>
  );
};

function mapStateToProps(state) {
  return {
    currentTab: state.currentTab.currentTab,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    nextTab: () => dispatch(nextTab()),
    preTab: () => dispatch(preTab()),
    customTab: (num) => dispatch(customTab(num)),
    resetCard: () => dispatch(resetCard()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BOA);
